export const defaultState = () => {
  return {
    assignedOnly: true,
    assignedOnlyQuery: true,
    product : {

      pageId: null,

      assignment: {
        assigned: [],
        selected: [],
        unselected: []
      },

      all: {
        list: [],
        products: [],
        queryList: [],
        fetched: false,
        queryFetched: false,
        page: 0,
        queryPage: 0,
        expandedList: [],
        endCursor: '',
        endCursorQuery: '',
      },

      pages: {
        list: [],
        products: [],
        queryList: [],
        fetched: false,
        queryFetched: false,
        page: 0,
        queryPage: 0,
        expandedList: [],
        endCursor: '',
        endCursorQuery: '',
      },

      collections: {
        list: [],
        products: [],
        queryList: [],
        fetched: false,
        queryFetched: false,
        page: 0,
        queryPage: 0,
        expandedList: [],
        endCursor: '',
        endCursorQuery: '',
      },
    }
  };
};

const state = defaultState();

export default state;
